export default "__VITE_ASSET__Dov6OrYY__"